export enum NewChaseActiveScreen {
  Project = 0,
  Member = 1,
  Address = 2,
  Provider = 3,
  Encounters = 4,
  Review = 5,
  Confirmation = 6,
}
